import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Injectable({
  providedIn:'root'
})
export class EapApplicationsResolve  {

  constructor(
    public commonService: CommonService
  ) {

  }
  resolve(route : ActivatedRouteSnapshot,state: RouterStateSnapshot):Observable<any>|Observable<never>
  {
   return forkJoin([
      this.commonService.GetColumns("5",true), 
      this.commonService.GetUserPreferencesColumns()
    ])
  }
}